// extracted by mini-css-extract-plugin
export var cell = "_5m-4";
export var headerCell = "_5m-2";
export var rowHeader = "_5m-3";
export var table = "_5m-1";
export var tableContainer = "_5m-0";